(() => {
  const route = window.Shopify?.routes?.root || '/';
  const section = document.querySelector('[data-fdp-logo-order]');
  const form = section?.querySelector('form');
  const config = section ? JSON.parse(section.querySelector('[data-fdp-logo-config]').textContent) : null;
  const boardIds = new Set([15975179125120,15975178797440,15975178961280,15975178338688]);
  const serviceId = 15998248518016;
  const isBoard = item => boardIds.has(Number(item.product_id));
  const isService = item => Number(item.product_id) === serviceId;
  let cart = null, busy = false, dirty = false, cleaning = false, hydrated = false;
  const status = form?.querySelector('[data-fdp-logo-status]');
  const checkout = form?.querySelector('[data-fdp-logo-checkout]');
  const file = form?.elements.logo_file;
  const mode = () => form?.querySelector('[name=logo_mode]:checked')?.value;
  const text = key => config?.text[key] || key;
  const fileUrl = value => {
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && /(^|\.)shopify\.com$/.test(url.hostname) && /\/uploads\//.test(url.pathname) ? url.href : '';
    } catch { return ''; }
  };
  const service = () => cart?.items.find(isService);
  const savedFile = () => {
    const line = service();
    return line?.properties?._fdp_logo_mode === mode() ? fileUrl(line.properties.Logo) : '';
  };
  async function request(path, body) {
    const multipart = body instanceof FormData;
    const response = await fetch(route + path, {
      method: body ? 'POST' : 'GET',
      headers: {Accept:'application/json', ...(!multipart && body ? {'Content-Type':'application/json'} : {})},
      ...(body ? {body: multipart ? body : JSON.stringify(body)} : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || text('error'));
    return data;
  }
  function refresh() {
    document.querySelector('[id^=fdp-home-]')?.dispatchEvent(new Event('fdp:cart-refresh'));
  }
  function choices() {
    if (!form) return;
    const needsFile = mode() === 'first' || mode() === 'replace';
    form.querySelector('[data-fdp-logo-upload]').hidden = !needsFile;
    file.disabled = !needsFile;
    file.required = needsFile && !savedFile();
    const link = form.querySelector('[data-fdp-logo-saved-file]');
    link.hidden = !needsFile || !savedFile();
    if (!link.hidden) link.href = savedFile();
    else link.removeAttribute('href');
    form.querySelector('[data-fdp-logo-fee]').textContent = mode() === 'replace' ? text('replace_fee') : mode() ? text('free_fee') : '';
  }
  async function cleanServices(current) {
    const updates = Object.fromEntries(current.items.filter(isService).map(item => [item.key,0]));
    if (Object.keys(updates).length) await request('cart/update.js',{updates});
  }
  function show(current) {
    cart = current;
    const hasBoards = current.items.some(isBoard);
    document.querySelectorAll('.additional-checkout-buttons').forEach(el => { el.hidden = hasBoards; el.style.display = hasBoards ? 'none' : ''; });
    if (!hasBoards && current.items.some(isService) && !busy && !cleaning) {
      cleaning = true;
      cleanServices(current).then(() => request('cart.js')).then(show).then(refresh).catch(() => {}).finally(() => {cleaning = false;});
    }
    if (!section) return;
    section.hidden = !hasBoards;
    document.querySelector('[data-fdp-plain-checkout]').hidden = hasBoards || !current.items.some(item => !isService(item));
    if (!hydrated && !dirty) {
      const line = service(), properties = line?.properties || {};
      const selected = properties._fdp_logo_mode;
      if (selected && form.querySelector('[name=logo_mode][value="'+selected+'"]')) {
        form.querySelector('[name=logo_mode][value="'+selected+'"]').checked = true;
      }
      form.elements.company.value = properties.Entreprise || form.elements.company.value;
      form.elements.email.value = properties['E-mail client'] || form.elements.email.value;
    }
    hydrated = true;
    choices();
  }
  function goToLogo() {
    const url = new URL(route,location.origin);
    url.searchParams.set('fdp','cake-boards');
    url.hash = 'fdp-cart';
    location.assign(url.href);
  }
  async function ordinaryCheckout() {
    const current = await request('cart.js');
    if (current.items.some(isBoard)) return goToLogo();
    await cleanServices(current);
    location.assign(route+'checkout');
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button[name=checkout], a[href], [data-fdp-plain-checkout]');
    if (!target || target.closest('[data-fdp-logo-order]')) return;
    const href = target.getAttribute('href');
    if (target.name !== 'checkout' && (!href || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?(?:\?|$)/i.test(href))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ordinaryCheckout().catch(error => {
      if (status) status.textContent = error.message;
      else location.assign(route+'?fdp=cake-boards#fdp-cart');
    });
  },true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout' || event.target === form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ordinaryCheckout().catch(() => goToLogo());
  },true);
  if (form) {
    form.addEventListener('pointerdown', () => { dirty = true; });
    form.addEventListener('input', () => { dirty = true; status.textContent = ''; });
    form.addEventListener('change', () => { dirty = true; status.textContent = ''; choices(); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      choices();
      if (!form.reportValidity()) return;
      const selectedMode = mode(), company = form.elements.company.value.trim(), email = form.elements.email.value.trim();
      if (!company || !email) {status.textContent = text('reference_required');return;}
      const upload = file.disabled ? null : file.files[0];
      if (upload && (upload.size > 10*1024*1024 || upload.size === 0 || !/\.(png|jpe?g|pdf)$/i.test(upload.name))) {status.textContent=text('file_error');return;}
      busy = true;
      checkout.disabled = true;
      form.querySelector('fieldset').disabled = true;
      status.textContent = text('saving');
      try {
        cart = await request('cart.js');
        if (!cart.items.some(isBoard)) { await cleanServices(cart);location.assign(route+'checkout');return; }
        if (!config.variants[selectedMode]) throw new Error(text('unavailable'));
        const old = service();
        const properties = {
          'Entreprise':company,
          'E-mail client':email,
          'Application':text('whole_order'),
          '_fdp_logo_mode':selectedMode,
          'Choix du logo':form.querySelector('[name=logo_mode]:checked').closest('label').innerText.trim()
        };
        const storedFile = savedFile();
        if (selectedMode !== 'existing' && !upload && !storedFile) throw new Error(text('file_required'));
        const matching = old && Number(old.variant_id) === Number(config.variants[selectedMode]) && !upload && Object.entries(properties).every(([key,value]) => old.properties?.[key] === value);
        let keep = matching ? old : null;
        if (!keep) {
          const body = new FormData();
          body.append('id',config.variants[selectedMode]);
          body.append('quantity','1');
          properties._fdp_logo_request = crypto.randomUUID();
          for (const [key,value] of Object.entries(properties)) body.append('properties['+key+']',value);
          if (upload) body.append('properties[Logo]',upload,upload.name);
          else if (selectedMode !== 'existing' && storedFile) body.append('properties[Logo]',storedFile);
          try { await request('cart/add.js',body); }
          catch (error) {
            cart = await request('cart.js');
            if (!cart.items.some(item => item.properties?._fdp_logo_request === properties._fdp_logo_request)) throw error;
          }
          cart = await request('cart.js');
          keep = cart.items.find(item => item.properties?._fdp_logo_request === properties._fdp_logo_request);
        }
        if (!keep || (selectedMode !== 'existing' && !fileUrl(keep.properties.Logo))) throw new Error(text('upload_error'));
        const updates = Object.fromEntries(cart.items.filter(isService).map(item => [item.key,item.key === keep.key ? 1 : 0]));
        cart = await request('cart/update.js',{updates});
        const lines = cart.items.filter(isService);
        if (lines.length !== 1 || lines[0].quantity !== 1 || Number(lines[0].original_price) !== (selectedMode === 'replace' ? 690 : 0)) throw new Error(text('fee_error'));
        dirty = false;
        file.value = '';
        show(cart);
        refresh();
        status.textContent = text('saved');
        location.assign(route+'checkout');
      } catch (error) {
        status.textContent = error.message || text('error');
      } finally {
        busy = false;
        checkout.disabled = false;
        form.querySelector('fieldset').disabled = false;
      }
    });
  }
  document.addEventListener('fdp:cart-updated',event => show(event.detail));
  request('cart.js').then(show).catch(error => {if(status) status.textContent=error.message;});
})();
